<template>
  <BaseDialog
    :show="true"
    title="啟用色系主題"
    :btn1Loading="loading"
    @confirm="onConfirm"
    @cancel="$emit('close')"
    @close="$emit('close')"
  >
    <div>
      <BaseElForm ref="formRef" :model="formData" :rules="formRules">
        <BaseElFormItem label="選擇色系範本" prop="enableTemplate">
          <BaseElSelect v-model="formData.enableTemplate" value-key="id">
            <BaseElSelectOption
              v-for="option in templateOptions"
              :key="option.id"
              :label="option.label"
              :value="option"
            />
          </BaseElSelect>
        </BaseElFormItem>
      </BaseElForm>
    </div>
  </BaseDialog>
</template>

<script>
import { defineComponent, computed, onMounted } from 'vue'
import BaseDialog from '@/components/Dialog/BaseDialog.vue'
import { useBaseForm } from '@/use/useForm'
import { noEmptyRules } from '@/validation'
import { map, get, find } from 'lodash'
import { UpdateClientPageConfig } from '@/api/member/memberCenter'
import { useShop } from '@/use/shop'
import { useFetch } from '@/use/fetch'

export default defineComponent({
  name: 'EnableMemberCardModal',
  components: { BaseDialog },
  props: {
    configData: { type: Object, default: () => ({}) },
    tableData: { type: Array, default: () => [] },
  },
  setup (props, { emit }) {
    const { formRef, initFormData, formData, loading, onSubmit } = useBaseForm()
    const { shopId } = useShop()
    const { simpleFetch } = useFetch()

    initFormData({
      enableTemplate: null,
    })

    const formRules = computed(() => {
      const rules = {
        enableTemplate: [noEmptyRules()],
      }
      return rules
    })

    const curTheme = computed(() => {
      const styleName = get(props.configData, 'colorStyle')
      if (styleName === 'custom') return get(props.configData, 'CustomColorStyleId')
      return `@system-${styleName}`
    })

    const templateOptions = computed(() => {
      return map(props.tableData, (item) => {
        const isSystemStyle = item.id.includes('@system-')
        return {
          label: item.displayName || item.name,
          value: isSystemStyle ? item.name : 'custom',
          id: item.id,
        }
      })
    })

    const onConfirm = async () => {
      await onSubmit(async (data) => {
        const styleId = get(data.enableTemplate, 'id')
        const isSystemStyle = styleId.includes('@system-')

        await simpleFetch(UpdateClientPageConfig, {
          shopId: shopId.value,
          colorStyle: get(data.enableTemplate, 'value'),
          CustomColorStyleId: isSystemStyle ? undefined : styleId,
        }, (res) => {
          window.$message.success('更新成功！')
          emit('refresh')
          emit('close')
        })
      }, formData)
    }

    onMounted(async () => {
      const res = find(props.tableData, { id: curTheme.value })
      const isSystemStyle = res.id.includes('@system-')
      formData.enableTemplate = {
        label: res.displayName || res.name,
        value: isSystemStyle ? res.name : 'custom',
        id: res.id,
      }
    })

    return { onConfirm, formRef, initFormData, formData, loading, formRules, templateOptions, curTheme }
  },
})
</script>

<style scoped lang="postcss">
</style>
